import script from "./not_available.vue?vue&type=script&setup=true&lang=js"
export * from "./not_available.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__